module.exports = __webpack_public_path__ + "static/media/personalized.5da6eb74.svg";